import { showHttpError } from '@calendly/alert'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { destroyGroup } from '../api'

export const destroyUserGroup = createAsyncThunk(
  'userGroup/destroy',
  async (groupId, { dispatch, rejectWithValue }) => {
    const [success, response] = await destroyGroup(groupId)

    if (!success) {
      dispatch(showHttpError(response))
      return rejectWithValue(null)
    }

    return groupId
  }
)
